module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('pg-container', {
    attrs: {
      "md": "3",
      "sm": "4",
      "xs": "12",
      "cls": "pagination-showing"
    }
  }, [_vm._v("\n    Showing "), _c('strong', [_vm._v(_vm._s((_vm.$pagination.page - 1) * _vm.$pagination.perPage + 1) + " - " + _vm._s(_vm.$pagination.page * _vm.$pagination.perPage > _vm.$pagination.total ? _vm.$pagination.total : _vm.$pagination.page * _vm.$pagination.perPage))]), _vm._v(" of " + _vm._s(_vm.$pagination.total) + " records\n  ")]), _vm._v(" "), _c('pg-container', {
    attrs: {
      "md": "9",
      "sm": "8",
      "xs": "12",
      "cls": "pagination-links"
    }
  }, [_c('pg-container', {
    attrs: {
      "md": "6",
      "sm": "12",
      "cls": "align-center"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    class: {
      'pagination-link': true, 'disabled': _vm.$pagination.page == 1
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.$pagination.page - 1)
      }
    }
  }, [_c('i', {
    staticClass: "pg-arrow_left"
  })])]), _vm._v(" "), _vm._l((_vm.pages), function(p) {
    return _c('li', [_c('a', {
      class: {
        'pagination-link': true, 'active': p === _vm.$pagination.page
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setPage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'pagination-link': true, 'disabled': _vm.$pagination.page == _vm.pagesTotal()
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPage(_vm.$pagination.page + 1)
      }
    }
  }, [_c('i', {
    staticClass: "pg-arrow_right"
  })])])], 2)]), _vm._v(" "), _c('pg-container', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('ul', _vm._l(([30, 50, 100, 500]), function(p) {
    return _c('li', [_c('a', {
      class: {
        'pagination-link': true, 'active': p === _vm.$pagination.perPage
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setPerPage(p)
        }
      }
    }, [_vm._v(_vm._s(p))])])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7517c6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pagination.vue
// module id = 1267
// module chunks = 1